import { useQuery, UseQueryResult } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { USER_GRADE_QUERY_KEYS } from './queryKeys';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { UserGradeHistoriesResponseType } from '../types';
import { GetUserGradeHistoriesUsecaseImpl } from '../usecases/GetUserGradeHistoriesUsecase';
import { UserGradeHistoryRespository } from '../repositories/UserGradeHistoryRespository';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';

type UseUserGradeHistoriesQueryArgsType<SelectResultType> = {
  userId: number;
  options: QueryOptions<UserGradeHistoriesResponseType, unknown, SelectResultType>;
};
export const useUserGradeHistoriesQuery = <SelectResultType>({
  userId,
  options,
}: UseUserGradeHistoriesQueryArgsType<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  const getUserGradeHistoriesUsecase = new GetUserGradeHistoriesUsecaseImpl(UserGradeHistoryRespository);
  return useQuery<UserGradeHistoriesResponseType, unknown, SelectResultType>(
    USER_GRADE_QUERY_KEYS.HISTORIES,
    () => getUserGradeHistoriesUsecase.invoke(userId, dayjs().format(DATE_FORMAT.YM_DASH_FORMAT)),
    {
      ...options,
    },
  );
};
